import { render, staticRenderFns } from "./SalaryPeriodForm.vue?vue&type=template&id=1792138a&scoped=true"
import script from "./SalaryPeriodForm.vue?vue&type=script&lang=js"
export * from "./SalaryPeriodForm.vue?vue&type=script&lang=js"
import style0 from "./SalaryPeriodForm.vue?vue&type=style&index=0&id=1792138a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792138a",
  null
  
)

export default component.exports